import api from '../services/api';
import { createBaseModule } from './base';

export default createBaseModule( {
  state: {
    localQuantity: 0
  },
  mutations: {
    SET_LOCAL_QUANTITY(state, quantity) {
      state.localQuantity = quantity;
    }
  },
  actions: {
    async fetchDetail({ commit, state }, id) {

      commit('RESET_STATE');

      try {
        commit('SET_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await api.get('api/catalog/detail/'+id+'/');
        commit('SET_DATA', {data:response.data.data});
        commit('SET_ERROR', null);
      } catch (error) {
        commit('SET_ERROR', error.message?error.message:'Ошибка при загрузке');
      } finally {
        commit('SET_LOADING', false);
      }
    },
    updateLocalQuantity({ commit }, quantity) {
      commit('SET_LOCAL_QUANTITY', quantity);
    }

  },
  getters: {
    product: state => state.data,
    productLoading: state => state.loading,
    productError: state => state.error,
    productLoaded: state => state.loaded,
    localQuantity: state => state.localQuantity
  }
})